import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { CustomInput } from '../type-input/custom-input';
import { faAngleDown, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { TipoParametro } from 'src/app/features/data-visualization/reports/models/parametro';
import { HelperFunctions } from 'src/app/util/util-functions';

@Component({
  selector: 'app-multiple-input',
  templateUrl: './multiple-input.component.html',
  styleUrls: ['./multiple-input.component.scss']
})
export class MultipleInputComponent implements OnChanges {
  @Input() formArray: FormArray;
  control: FormControl = new FormControl(null);
  @Input() input: CustomInput;
  parameterType: typeof TipoParametro = TipoParametro;
  faCircleXmark = faCircleXmark;
  faAngleDown = faAngleDown;

  /**
   * A function that checks if the control is invalid
   * @returns {boolean}
   */
  hasErrors(): boolean {
    return HelperFunctions.controlIsInvalid(this.formArray);
  }

  /**
   * A function that add a parameter value to the form array
   * @returns None
   */
  formatValue(): void {
    let value = this.control?.value;
    if (value) {
      value = this.input.type === this.parameterType.date ? HelperFunctions.getStringOfNgbDate(value) : value.toString();
      if (value.trim().length > 0) {
        this.addValue(value);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const input = changes['input'];
    if (input.currentValue?.type !== input.previousValue?.type) {
      this.control.reset();
    }
  }

  /**
 * A function that add a parameter value to the form array
 * @param {any} option
 * @returns None
 */
  addValue(option: string): void {
    let isValid = this.formArray.controls.every((control) => control.value !== option);
    if (isValid) {
      this.formArray.push(new FormControl(option));
      this.control.reset();
    }
  }
  /**
 * A function that remove the parameter value by index
 * @param {number} index
 * @returns None
 */
  removeParameterValue(index: number): void {
    this.formArray.markAllAsTouched();
    this.formArray.removeAt(index);
  }
}
